import Vue from 'vue'
import store from '@/store'
import { publicPath } from '@/../vue.config'
import router from '@/router'

import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

axios.interceptors.request.use((request) => {
  if (!request.url.match(/meetings\/[0-9]+$/) && !request.url.match(/meetings\/[0-9]+\/slots$/)) {
    store.commit('clearResponse');
  }
  if (!request.url.match(/comments$/)) {
    store.commit('setProgress', true);
  }
  return request;
}, (error) => {
  return Promise.reject(error);
});

axios.interceptors.response.use((response) => {
  return response;
}, (error) => {
  // Avoid leaving the global spinner stuck forever on any request failure
  store.commit('setProgress', false);

  const status = error && error.response ? error.response.status : null;

  if (!['/login'].includes(router.currentRoute.path) && [401,403].includes(status)) {
    localStorage.removeItem('x-api-key');
    Vue.axios.defaults.headers.common['x-api-key'] = null;
    store.commit('setKey', null, { root: true });
    window.history.pushState({}, document.title, publicPath);
    store.commit('setProgress', false);
    store.commit('setResponse', { status: true, type: 'error', message: 'login_error', errors: { login: 'Permission denied' } }, { root: true });
    router.push('/login');
  }
  return Promise.reject(error);
});
